module.exports = __webpack_public_path__ + "media/images/pic/adventure-green-bd3045f0537859dc696e65d2d3ff361a.svg";